import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { twMerge } from 'tailwind-merge';

import { ReactComponent as IconCommentActive } from '../../icons/icon-comment-active-inline.svg';
import { BottomActionButton } from './BottomActionButton';

const messages = defineMessages({ answer: { defaultMessage: 'Reply', id: '9HU8vw' } });

type AnswerBottomActionProps = {
  answer: () => void;
  className?: string;
};
export const AnswerBottomAction: React.FC<AnswerBottomActionProps> = ({ answer, className }) => {
  const { formatMessage } = useIntl();
  return (
    <BottomActionButton
      className={twMerge('AnswerBottomAction hover:text-gray', className)}
      icon={<IconCommentActive className="w-3 h-3" />}
      label={formatMessage(messages.answer)}
      onClick={answer}
    />
  );
};
